import cx from "classnames";
import { ReactNode } from "react";

import { Icon } from "../Icon";
import { Icons } from "../Icon/types";
import message from "./message.module.css";

type MessageType = "confirm" | "info" | "warning" | "error";

type MessageProps = {
  type?: MessageType;
  icon?: Icons;
  hideIcon?: boolean;
  className?: string;
  children: ReactNode;
};

const ICONS: Record<MessageType, Icons> = {
  confirm: "checkmark_circle",
  info: "info",
  warning: "exclamation",
  error: "exclamation",
};

export const Message = ({
  type = "info",
  hideIcon = false,
  icon,
  className,
  children,
}: MessageProps) => (
  <div className={cx(message.container, message[type], className)}>
    {!hideIcon && <Icon type={icon ?? ICONS[type]} />}
    <p>{children}</p>
  </div>
);
